<template>
  <div class="home">
    <div class="banner">
      <img class="logo" src="../../static/img/logo.png" />
      <h5><span>|</span> 会员系统</h5>
      <div class="user_msg">
        <img src="../../static/img/icon1.png" />
        <div>
          <strong>{{ name }}</strong>
          <p>
            会员编号：<span>{{ bh }}</span>
          </p>
        </div>
        <span class="out" @click="out">退出</span>
      </div>
    </div>
    <div class="center">
      <div class="shade" v-show="tc">
        <div class="tc">
          <p class="tc_tit">
            提示 <span class="closed" @click="cancel"></span>
          </p>
          <p>您是否要退出，如果退出，数据将会丢失</p>
          <div>
            <span class="no" @click="cancel">取消</span>
            <span class="sure" @click="out1">确定</span>
          </div>
        </div>
      </div>
      <div class="con_con">
        <div class="con_con_top">
          中国质量协会{{ jieshu }}{{ zhiwei }}信息登记表
        </div>
        <div class="con_con_form">
          <p class="con_con_form_tit">个人信息</p>
          <div class="con_con_item" style="margin-bottom: 20px">
            <span class="type1">类别</span>
            <el-radio-group v-model="lb">
              <el-radio label="企业组织"></el-radio>
              <el-radio label="政府部门"></el-radio>
              <el-radio label="人民团体 行业协会"></el-radio>
              <el-radio label="质协系统"></el-radio>
              <el-radio label="专家学者"></el-radio>
              <el-radio label="新闻媒体"></el-radio>
              <el-radio label="其他"></el-radio>
            </el-radio-group>
          </div>
          <div class="con_con_item">
            <span class="type1">姓名</span>
            <input
              style="width: 120px"
              type="text"
              class="form_name"
              v-model="form_name"
            />
            <span style="width: 61px">性别</span>
            <el-radio-group v-model="sex">
              <el-radio label="男"></el-radio>
              <el-radio label="女"></el-radio>
            </el-radio-group>
            <span style="width: 100px">出生日期</span>
            <el-date-picker v-model="data1" type="date" style="width: 151px">
            </el-date-picker>
            <span style="width: 61px">民族</span>
            <input style="width: 161px" type="text" v-model="people_kind" />
          </div>
          <div class="con_con_item">
            <span class="type1">身份证号码</span>
            <input style="width: 550px" type="text" v-model="form_code" />
            <span style="width: 122px">中管干部</span>
            <el-radio-group v-model="or">
              <el-radio label="是"></el-radio>
              <el-radio label="否"></el-radio>
            </el-radio-group>
          </div>
          <div class="con_con_item">
            <span class="type1">工作单位</span>
            <input style="width: 550px" type="text" v-model="danwei" />
            <span style="width: 65px">职务</span>
            <input style="width: 161px" type="text" v-model="zhiwu" />
          </div>
          <div class="con_con_item">
            <span class="type1">政治面貌</span>
            <input style="width: 108px" type="text" v-model="zzmm" />
            <span style="width: 65px">学位</span>
            <input style="width: 158px" type="text" v-model="xw" />
            <span style="width: 65px">学历</span>
            <input style="width: 95px" type="text" v-model="xl" />
            <span style="width: 65px">专业</span>
            <input style="width: 200px" type="text" v-model="zy" />
          </div>
          <div class="con_con_item">
            <span class="type1">专业技术职称</span>
            <input style="width: 208px" type="text" v-model="zc" />
            <span style="width: 300px">在其他社会组织中担任任何领导职位</span>
            <input style="width: 267px" type="text" v-model="yet_leader" />
          </div>
          <div class="con_con_item">
            <span class="type1">通讯地址</span>
            <input style="width: 208px" type="text" v-model="txdz" />
            <span style="width: 125px">邮编</span>
            <input style="width: 208px" type="text" v-model="yb" />
            <span style="width: 65px">传真</span>
            <input style="width: 161px" type="text" v-model="cz" />
          </div>
          <div class="con_con_item" style="margin-bottom: 61px">
            <span class="type1">联系电话</span>
            <input style="width: 208px" type="text" v-model="lxdh" />
            <span style="width: 125px">手机</span>
            <input style="width: 208px" type="text" v-model="sj" />
            <span style="width: 65px">电子邮箱</span>
            <input style="width: 161px" type="text" v-model="dzyx" />
          </div>
          <div class="con_con_form_center">
            <p>工 作 简 历</p>
            <div class="con_con_table">
              <ul>
                <li>起止时间</li>
                <li>工作单位</li>
                <li>职务</li>
              </ul>
              <textarea
                style="
                  width: 99.5%;
                  height: 280px;
                  border: none;
                  padding: 10px 0 0 20px;
                  box-sizing: border-box;
                "
                v-model="area"
                :placeholder="defaultContent"
              ></textarea>
            </div>
          </div>
          <!-- 
					<div class="con_con_item1">
						<p class="flex fl clearfix">推荐担任{{zhiwei}}职务<br/>及 <br/>本人承诺 </p>
						<div class="flex fr clearfix">本人同意担任中国质量协会{{zhiwei}}职务，按时出席中国质协主要会议和重大活动，愿意为实施质量兴国战略，推进中国质量事业做出贡献。</div>
					</div> -->
          <p class="con_con_form_tit">联系人信息</p>
          <div
            class="con_con_item"
            style="
              display: flex;
              align-items: center;
              justify-content: space-between;
              margin-bottom: 100px;
            "
          >
            <span class="type1">姓名</span>
            <input
              style="width: 120px"
              type="text"
              class="form_name"
              v-model="lName"
            />
            <span style="width: 61px">职务</span>
            <input
              style="width: 135px"
              type="text"
              class="form_name"
              v-model="lPost"
            />
            <span style="width: 60px">电话</span>
            <input
              style="width: 120px"
              type="text"
              class="form_name"
              v-model="lPhone"
            />
            <span style="width: 61px">邮箱</span>
            <input style="width: 161px" type="text" v-model="lEmail" />
          </div>
          <button class="btn" @click="summit" v-if="btn">提交</button>
          <button class="btn" @click="summit1" v-else>提交</button>
        </div>
      </div>
    </div>
    <bottom></bottom>
  </div>
</template>

<script>
import { Loading } from 'element-ui';
import area from '../../static/js/area.js';
import Qs from 'qs';
import bottom from './Bottom'
export default {
  components: {
    bottom
  },
  data () {
    return {
      director_id: '',
      defaultContent: '请按时间顺序由近到远填写，例如：2015-2019，A企业，总经理；\n\n2013-2015，B企业，副总经理；\n\n2007-2013，C企业，副总经理；',
      tc: false,
      jieshu: '',
      zhiwei: '',
      btn: true,
      name: '',
      bh: '',
      form_name: '',
      sex: '',
      data1: '',
      people_kind: '',
      form_code: '',
      or: '',
      danwei: '',
      zhiwu: '',
      zzmm: '',
      xw: '',
      xl: '',
      zy: '',
      zc: '',
      yet_leader: '',
      txdz: '',
      yb: '',
      cz: '',
      lxdh: '',
      sj: '',
      dzyx: '',
      area: '',
      lb: '',
      lName: '',
      lPost: '',
      lPhone: '',
      lEmail: '',
    };
  },

  created () { },
  mounted () {
    if (sessionStorage.getItem('name')) {
      this.name = sessionStorage.getItem('name');
    };
    if (sessionStorage.getItem('bh')) {
      this.bh = sessionStorage.getItem('bh');
    };
    if (sessionStorage.getItem('Token')) {
      var token = sessionStorage.getItem('Token');
    };
    var data = {
      'access-token': token
    };
    this.$axios({
      method: 'post',
      url: 'director/numbertochinese',
      data: Qs.stringify(data)
    }).then(response => {
      console.log(response.data);
      this.jieshu = '第' + response.data + '届';
    })

    if (sessionStorage.getItem('type')) {
      switch (Number(sessionStorage.getItem('type'))) {
        case 2:
          //企业用户判断理事类型
          switch (Number(sessionStorage.getItem('zhiwei'))) {
            case 0:
              break;
            case 1:
              //理事	
              this.zhiwei = '理事';
              break;
            case 2:
              //常务理事
              this.zhiwei = '常务理事';
              break;

            case 3:
              //副会长	
              this.zhiwei = '副会长';
              break;
          };
          break;
        case 4:
          //特邀 常务理事	
          this.zhiwei = '常务理事';
          break;
        case 5:
          //特邀 副会长
          this.zhiwei = '副会长';
          break;
      }
    };

    if (sessionStorage.getItem('dengJi_id')) {
      var dengJi_id = sessionStorage.getItem('dengJi_id');
      this.director_id = sessionStorage.getItem('dengJi_id');
    };

    //编辑信息
    var datas = {
      director_id: dengJi_id,
      'access-token': token
    };
    this.$axios({
      method: 'post',
      url: 'director/directorinfoone',
      data: Qs.stringify(datas)
    }).then(response => {
      console.log(response.data);
      if (response.data.state == 2 && response.data.data != '') {
        this.btn = false;
        this.lb = response.data.data.professions;
        this.form_name = response.data.data.name;
        this.sex = response.data.data.sex;
        this.data1 = response.data.data.birthdate;
        this.people_kind = response.data.data.people;
        this.form_code = response.data.data.id_number;
        if (response.data.data.manager == 1) {
          this.or = '是';
        } else {
          this.or = '否';
        };
        this.danwei = response.data.data.company_name;
        this.zhiwu = response.data.data.post;
        this.zzmm = response.data.data.politics_status;
        this.xw = response.data.data.degree;
        this.xl = response.data.data.education;
        this.zy = response.data.data.major;
        this.zc = response.data.data.professional_title;
        this.yet_leader = response.data.data.else_title;
        this.txdz = response.data.data.present_address;
        this.yb = response.data.data.postcode;
        this.lxdh = response.data.data.phone;
        this.cz = response.data.data.fax;
        this.sj = response.data.data.mobile;
        this.dzyx = response.data.data.email;
        this.area = response.data.data.work_experience;
        this.lName = response.data.data.other_name;
        this.lPost = response.data.data.other_post;
        this.lPhone = response.data.data.other_tel;
        this.lEmail = response.data.data.other_email;
        switch (Number(response.data.data.director_type)) {
          case 1:
            this.zhiwei = '理事';
            break;
          case 2:
            this.zhiwei = '常务理事';
            break;
          default:
            this.zhiwei = '副会长';
        }
      } else {
        this.$toast(response.data.msg);
      }
    })
  },
  methods: {
    cancel () {
      this.tc = false;
    },
    out () {
      this.tc = true;
    },
    out1 () {
      if (sessionStorage.getItem('Token')) {
        var token = sessionStorage.getItem('Token');
      };
      var data1 = {
        'access-token': token
      };
      this.$axios({
        method: 'post',
        url: 'user/logout',
        data: Qs.stringify(data1)
      }).then(response => {
        console.log(response.data);
        if (response.data.state == 1) {
          localStorage.clear();
          sessionStorage.clear();
          this.$router.push('/login');
        } else {
          this.$toast(response.data.msg);
        }
      })
    },
    summit () {
      if (!this.form_name) {
        this.$toast('请输入姓名');
        return false;
      };
      if (!this.sex) {
        this.$toast('请选择性别')
        return false;
      };
      if (!this.data1) {
        this.$toast('请选择出生日期');
        return false;
      };
      if (!this.people_kind) {
        this.$toast('请输入民族')
        return false;
      };
      if (!this.form_code) {
        this.$toast('请输入身份证号码')
        return false;
      };
      if (!this.or) {
        this.$toast('请选择是否是中管干部')
        return false;
      };
      if (!this.danwei) {
        this.$toast('请输入单位名称')
        return false;
      };
      if (!this.zhiwu) {
        this.$toast('请输入职务')
        return false;
      };
      if (!this.zzmm) {
        this.$toast('请输入政治面貌')
        return false;
      };
      if (!this.xw) {
        this.$toast('请输入学位')
        return false;
      };
      if (!this.xl) {
        this.$toast('请输入学历')
        return false;
      };
      if (!this.zy) {
        this.$toast('请输入专业')
        return false;
      };
      if (!this.zc) {
        this.$toast('请输入专业技术职称')
        return false;
      };
      if (!this.yet_leader) {
        this.$toast('请输入曾经担任的领导职务')
        return false;
      };
      if (!this.txdz) {
        this.$toast('请输入通讯地址')
        return false;
      };
      if (!this.yb) {
        this.$toast('请输入邮编')
        return false;
      };
      if (!this.cz) {
        this.$toast('请输入传真')
        return false;
      };
      if (!this.lxdh) {
        this.$toast('请输入联系电话')
        return false;
      };
      if (!this.sj) {
        this.$toast('请输入手机号码')
        return false;
      };
      var reg = /^[1][3,4,5,7,8,9][0-9]{9}$/;
      if (!reg.test(this.sj)) {
        this.$toast('请输入正确的手机号码')
        return false;
      };

      if (!this.dzyx) {
        this.$toast('请输入电子邮箱')
        return false;
      };
      if (!this.area) {
        this.$toast('请输入工作简历')
        return false;
      };
      if (!this.lb) {
        this.$toast('请选择类别')
        return false;
      };

      if (!this.lName) {
        this.$toast('请输入联系人姓名')
        return false;
      };
      if (!this.lPost) {
        this.$toast('请输入联系人职务')
        return false;
      };
      if (!this.lPhone) {
        this.$toast('请输入联系人电话')
        return false;
      };
      if (!this.lEmail) {
        this.$toast('请输入联系人邮箱')
        return false;
      };


      Loading.service();
      if (this.or == '是') {
        this.or = 1;
      } else {
        this.or = 2;
      };
      if (this.zhiwei == '理事') {
        this.zhiwei = 1;
      } else if (this.zhiwei == '常务理事') {
        this.zhiwei = 2;
      } else if (this.zhiwei == '副会长') {
        this.zhiwei = 3;
      };
      if (sessionStorage.getItem('Token')) {
        var token = sessionStorage.getItem('Token');
      };
      var data = {
        'access-token': token,
        'professions': this.lb,
        'name': this.form_name,
        'sex': this.sex,
        'birthdate': this.data1.toISOString().slice(0, 10),
        'people': this.people_kind,
        'id_number': this.form_code,
        'manager': this.or,
        'company_name': this.danwei,
        'post': this.zhiwu,
        'politics_status': this.zzmm,
        'degree': this.xw,
        'education': this.xl,
        'major': this.zy,
        'professional_title': this.zc,
        'else_title': this.yet_leader,
        'present_address': this.txdz,
        'postcode': this.yb,
        'phone': this.lxdh,
        'fax': this.cz,
        'mobile': this.sj,
        'email': this.dzyx,
        'work_experience': this.area,
        'director_type': this.zhiwei,
        'other_name': this.lName,
        'other_post': this.lPost,
        'other_tel': this.lPhone,
        'other_email': this.lEmail,
      };
      this.$axios({
        method: 'post',
        url: 'director/director',
        data: Qs.stringify(data)
      }).then(response => {
        console.log(response.data);
        let loadingInstance = Loading.service();
        loadingInstance.close();
        if (response.data.state == 6) {
          sessionStorage.setItem('dengJi_id', response.data.director_id);
          this.$router.push('/table');
        } else {
          this.$toast(response.data.msg);
        }
      });
    },
    summit1 () {
      if (!this.form_name) {
        this.$toast('请输入姓名');
        return false;
      };
      if (!this.sex) {
        this.$toast('请选择性别')
        return false;
      };
      if (!this.data1) {
        this.$toast('请选择出生日期');
        return false;
      };
      if (!this.people_kind) {
        this.$toast('请输入民族')
        return false;
      };
      if (!this.form_code) {
        this.$toast('请输入身份证号码')
        return false;
      };
      if (!this.or) {
        this.$toast('请选择是否是中管干部')
        return false;
      };
      if (!this.danwei) {
        this.$toast('请输入单位名称')
        return false;
      };
      if (!this.zhiwu) {
        this.$toast('请输入职务')
        return false;
      };
      if (!this.zzmm) {
        this.$toast('请输入政治面貌')
        return false;
      };
      if (!this.xw) {
        this.$toast('请输入学位')
        return false;
      };
      if (!this.xl) {
        this.$toast('请输入学历')
        return false;
      };
      if (!this.zy) {
        this.$toast('请输入专业')
        return false;
      };
      if (!this.zc) {
        this.$toast('请输入专业技术职称')
        return false;
      };
      if (!this.yet_leader) {
        this.$toast('请输入曾经担任的领导职务')
        return false;
      };
      if (!this.txdz) {
        this.$toast('请输入通讯地址')
        return false;
      };
      if (!this.yb) {
        this.$toast('请输入邮编')
        return false;
      };
      if (!this.cz) {
        this.$toast('请输入传真')
        return false;
      };
      if (!this.lxdh) {
        this.$toast('请输入联系电话')
        return false;
      };
      if (!this.sj) {
        this.$toast('请输入手机号码')
        return false;
      };
      var reg = /^[1][3,4,5,7,8,9][0-9]{9}$/;
      if (!reg.test(this.sj)) {
        this.$toast('请输入正确的手机号码')
        return false;
      };

      if (!this.dzyx) {
        this.$toast('请输入电子邮箱')
        return false;
      };
      if (!this.area) {
        this.$toast('请输入工作简历')
        return false;
      };
      if (!this.lb) {
        this.$toast('请选择类别')
        return false;
      };

      if (!this.lName) {
        this.$toast('请输入联系人姓名')
        return false;
      };
      if (!this.lPost) {
        this.$toast('请输入联系人职务')
        return false;
      };
      if (!this.lPhone) {
        this.$toast('请输入联系人电话')
        return false;
      };
      if (!this.lEmail) {
        this.$toast('请输入联系人邮箱')
        return false;
      };

      Loading.service();
      if (this.or == '是') {
        this.or = 1;
      } else {
        this.or = 2;
      };
      if (this.zhiwei == '理事') {
        this.zhiwei = 1;
      } else if (this.zhiwei == '常务理事') {
        this.zhiwei = 2;
      } else if (this.zhiwei == '副会长') {
        this.zhiwei = 3;
      };
      if (sessionStorage.getItem('Token')) {
        var token = sessionStorage.getItem('Token');
      };
      var data = {
        'access-token': token,
        'director_id': this.director_id,
        'professions': this.lb,
        'name': this.form_name,
        'sex': this.sex,
        'birthdate': typeof (this.data1) == 'string' ? this.data1 : this.data1.toISOString().slice(0, 10),
        'people': this.people_kind,
        'id_number': this.form_code,
        'manager': this.or,
        'company_name': this.danwei,
        'post': this.zhiwu,
        'politics_status': this.zzmm,
        'degree': this.xw,
        'education': this.xl,
        'major': this.zy,
        'professional_title': this.zc,
        'else_title': this.yet_leader,
        'present_address': this.txdz,
        'postcode': this.yb,
        'phone': this.lxdh,
        'fax': this.cz,
        'mobile': this.sj,
        'email': this.dzyx,
        'work_experience': this.area,
        'director_type': this.zhiwei,
        'other_name': this.lName,
        'other_post': this.lPost,
        'other_tel': this.lPhone,
        'other_email': this.lEmail,
      };
      this.$axios({
        method: 'post',
        url: 'director/updirector',
        data: Qs.stringify(data)
      }).then(response => {
        console.log(response.data);
        let loadingInstance = Loading.service();
        loadingInstance.close();
        if (response.data.state == 6) {
          this.$router.push('/table');
        } else {
          this.$toast(response.data.msg);
        }
      });
    }
  }
}
</script>
<style scoped>
.clearfix::after {
  content: ".";
  clear: both;
  visibility: hidden;
  height: 0;
  display: block;
  line-height: 0;
}

.clearfix {
  zoom: 1;
}

.fl {
  float: left;
}

.fr {
  float: right;
}

.inline {
  display: inline-block;
}

.v_middle {
  vertical-align: middle;
}

.cur {
  cursor: pointer;
}

.rap {
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.flex {
  display: flex;
  align-items: center;
  justify-content: center;
}

.out {
  height: 40px;
  line-height: 40px;
  color: #808080;
  float: right;
  font-weight: bold;
  cursor: pointer;
}

.home {
  width: 100%;
  height: auto;
  background: #fff;
  font-family: PingFangSC-Regular;
  font-size: 14px;
  color: #404040;
  text-align: left;
}

.banner {
  width: 1196px;
  height: 80px;
  position: relative;
  margin: 0 auto;
}

.logo {
  width: 211px;
  height: 42px;
  position: absolute;
  top: 16px;
  left: 0;
}

.banner h5 {
  position: absolute;
  top: 26px;
  left: 227px;
  height: 28px;
  font-size: 20px;
  font-weight: bold;
  color: rgba(0, 94, 179, 1);
  line-height: 28px;
}

.banner h5 span {
  height: 17px;
  color: #e8e8e8;
}

.user_msg {
  width: 435px;
  padding-top: 22px;
  height: 40px;
  position: absolute;
  top: 0;
  right: 0;
}

.warn {
  height: 25px;
  line-height: 25px;
  float: left;
  color: #7d7d7d;
  padding-left: 33px;
  background: url(../../static/img/ling.png) no-repeat top left;
  background-size: 24px 25px;
}

.user_msg img {
  float: left;
  width: 40px;
  height: 35px;
  margin: 0 15px 0 31px;
}

.user_msg div {
  padding-right: 20px;
  text-align: left;
  float: left;
  width: 168px;
  height: 100%;
}

.user_msg div p {
  font-size: 12px;
  color: #bfbfbf;
}

.center {
  width: 100%;
  height: auto;
  background: #f6f8f9;
  padding-bottom: 32px;
  padding-top: 40px;
}
.shade {
  width: 100%;
  height: 100%;
  background: rgba(0, 0, 0, 0.7);
  position: fixed;
  left: 0;
  top: 0;
  z-index: 99;
}
.tc {
  width: 384px;
  height: 185px;
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  background: rgba(255, 255, 255, 1);
  box-shadow: 0px 4px 12px 0px rgba(0, 0, 0, 0.15);
  border-radius: 4px;
  padding: 16px 24px;
  box-sizing: border-box;
  text-align: center;
}
.tc_tit {
  position: relative;
  font-size: 16px;
  font-weight: bold;
  text-align: left;
  height: 20px;
  line-height: 20px;
  margin-bottom: 20px;
}
.closed {
  width: 14px;
  height: 14px;
  background: url(../../static/img/close.png) no-repeat;
  background-size: 100%;
  position: absolute;
  right: 0;
  top: 3px;
}
.tc div {
  position: absolute;
  bottom: 35px;
  left: 0;
  width: 100%;
  margin: 0 auto;
  box-sizing: border-box;
  padding: 0 80px;
  height: 24px;
}
.tc div span {
  cursor: pointer;
  line-height: 22px;
  color: #fff;
  float: left;
  width: 72px;
  height: 24px;
  background: rgba(24, 144, 255, 1);
  border-radius: 4px;
}
.tc .sure {
  float: right;
}
.con_con {
  margin: 0 auto;
  padding: 22px 36px 52px 26px;
  width: 952px;
  height: auto;
  background: rgba(255, 255, 255, 1);
  border: 1px solid rgba(207, 212, 214, 1);
  box-sizing: border-box;
}

.con_con_top {
  position: relative;
  text-align: center;
  height: 57px;
  line-height: 57px;
  font-size: 16px;
  font-weight: bold;
  border-bottom: 1px solid rgba(207, 212, 214, 1);
}

.con_con_top a {
  position: absolute;
  right: 0;
  bottom: 0;
  height: 30px;
  line-height: 30px;
  color: #0076ff;
  font-size: 14px;
}

.con_con_form {
  width: 100%;
  height: auto;
  color: #4f4f4f;
  font-weight: bold;
}

.con_con_form_tit {
  line-height: 58px;
  font-weight: bold;
  text-indent: 28px;
}

.con_con_item {
  width: 100%;
  height: 40px;
  margin-bottom: 30px;
}

.con_con_item input[type="text"] {
  height: 40px;
  border: none;
  border: 1px solid rgba(207, 212, 214, 1);
  box-sizing: border-box;
  border-radius: 5px;
  text-indent: 18px;
}

.con_con_item span {
  display: inline-block;
  text-align: center;
}

.con_con_item .type1 {
  width: 85px;
  line-height: 40px;
  text-align: right;
  margin-right: 10px;
}

.con_con_form_center {
  border-top: 1px solid rgba(0, 0, 0, 0);
  width: 100%;
  height: 348px;
  box-sizing: border-box;
  margin-bottom: 20px;
}

.con_con_form_center p {
  float: left;
  width: 14px;
  height: 100px;
  font-weight: bold;
  color: rgba(79, 79, 79, 1);
  line-height: 20px;
  margin: 122px 0 0 40px;
}

.con_con_table {
  float: right;
  width: 788px;
  height: 348px;
  border: 1px solid rgba(215, 215, 215, 1);
  box-sizing: border-box;
}

.con_con_table ul {
  width: 100%;
  height: 56px;
  background: rgba(251, 251, 251, 1);
  border-bottom: 1px solid rgba(215, 215, 215, 1);
}

.con_con_table ul li {
  float: left;
  width: 33%;
  line-height: 56px;
  text-align: center;
}

.con_con_table_body {
  padding: 15px 0 0 25px;
}

.con_con_table_body input {
  width: 208px;
}

.con_con_item1 {
  width: 100%;
  height: 150px;
  margin-bottom: 20px;
}

.con_con_item1 p {
  text-align: center;
  width: 40px;
  height: 150px;
  font-weight: bold;
  color: rgba(79, 79, 79, 1);
  margin-left: 40px;
}

.con_con_item1 div {
  border: 1px solid rgba(207, 212, 214, 1);
  width: 786px;
  height: 100%;
  box-sizing: border-box;
}

.btn {
  display: block;
  border: none;
  width: 160px;
  height: 48px;
  background: rgba(0, 118, 255, 1);
  border-radius: 4px;
  color: #fff;
  margin: 0 auto;
}
</style>


// WEBPACK FOOTER //
// src/components/Form.vue